import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { cssProperties } from "../utils/commonCssProperties";

const cellStyle = {
  whiteSpace: "nowrap",
  textAlign: "center",
};

export default function PreferenceWiseTableForAllCourses({
  tableData = [],
  columnData = [],
}) {
  const [rows, setRows] = React.useState(tableData);

  React.useEffect(() => {
    setRows(tableData);
  }, [tableData]);

  /** ================= TOTAL ROW ================= */
  const totalRow = React.useMemo(() => {
    if (!rows.length) return null;

    const totals = {};

    columnData.forEach((col) => {
      if (!["preference_no", "course_name"].includes(col.dataIndex)) {
        totals[col.dataIndex] = rows.reduce(
          (sum, r) => sum + Number(r[col.dataIndex] || 0),
          0
        );
      }
    });

    return {
      preference_no: "TOTAL",
      course_name: "",
      ...totals,
    };
  }, [rows, columnData]);

  return (
    <TableContainer
      component={Paper}
      sx={{
        background: "none",
        border: `1px solid ${cssProperties.bordercolor.primary2blue}`,
        boxShadow: "none",
      }}
    >
      <Table stickyHeader>
        {/* ================= HEADER ================= */}
        <TableHead>
          <TableRow>
            {columnData.map((col, index) => (
              <TableCell
                key={index}
                align="center"
                sx={{
                  fontWeight: "bold",
                  color: cssProperties.bordercolor.primary2blue,
                  borderRight: `1px solid ${cssProperties.bordercolor.primary2blue}`,
                  ...cellStyle,
                }}
              >
                {col.name}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        {/* ================= BODY ================= */}
        <TableBody>
          {rows.length ? (
            <>
              {rows.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {columnData.map((col, colIndex) => (
                    <TableCell
                      key={`${rowIndex}-${colIndex}`}
                      align="center"
                      sx={{
                        borderRight: `1px solid ${cssProperties.bordercolor.primary2blue}`,
                        ...cellStyle,
                      }}
                    >
                      {row[col.dataIndex] ?? "-"}
                    </TableCell>
                  ))}
                </TableRow>
              ))}

              {/* ================= TOTAL ROW ================= */}
              {totalRow && (
                <TableRow sx={{ backgroundColor: "#f5f8ff" }}>
                  {columnData.map((col, index) => (
                    <TableCell
                      key={`total-${index}`}
                      align="center"
                      sx={{
                        fontWeight: "bold",
                        borderRight: `1px solid ${cssProperties.bordercolor.primary2blue}`,
                        ...cellStyle,
                      }}
                    >
                      {totalRow[col.dataIndex] ?? ""}
                    </TableCell>
                  ))}
                </TableRow>
              )}
            </>
          ) : (
            <TableRow>
              <TableCell
                colSpan={columnData.length}
                align="center"
                sx={{ color: cssProperties.bordercolor.primary2blue }}
              >
                No Result Found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
